import React from "react";
import aboutImg from "../images/homepage/bf.png";

export default function AboutNew() {
  return (
    <div className="about-section-new">
      <div className="container">
        <div className="about-container">
          <div className="about-text-content">
            <h2>About CALYX</h2>
            <p>
              CALYX is a premium hair care brand dedicated to providing
              professional-quality products that transform your hair care
              routine. Our expertly formulated shampoo and conditioner are
              designed to meet the diverse needs of all hair types.
            </p>
            <p>
              Founded on the principle that everyone deserves salon-quality hair
              care, we combine natural ingredients with cutting-edge technology
              to create products that deliver exceptional results.
            </p>
          </div>
          <div className="about-image-content">
            <img src={aboutImg} alt="About CALYX" />
          </div>
        </div>
      </div>
    </div>
  );
}
